module.exports = __webpack_public_path__ + "img/juliaAndAlexanderRing@2x.27a13cd.jpg";